import { render, staticRenderFns } from "./ProductSettings.vue?vue&type=template&id=7a5c2072"
import script from "./ProductSettings.vue?vue&type=script&lang=ts"
export * from "./ProductSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a5c2072')) {
      api.createRecord('7a5c2072', component.options)
    } else {
      api.reload('7a5c2072', component.options)
    }
    module.hot.accept("./ProductSettings.vue?vue&type=template&id=7a5c2072", function () {
      api.rerender('7a5c2072', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/default/ProductSettings.vue"
export default component.exports